import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';

import './styles.scss';

import audioNo from 'assets/sounds/no/2 1 ordkjedetekst.mp3';
import audioNn from 'assets/sounds/nn/2 1 ordkjedetekst.mp3';

import audioNoNorming from 'assets/sounds/adult/ordkjdetesten/no/2 1 ordkjedetekst-norming.mp3';
import audioNnNorming from 'assets/sounds/adult/ordkjdetesten/nn/2 1 ordkjedetekst.m4a';
const audioObj = {
	no: audioNo,
	nn: audioNn,
};

const audioObjNorming = {
	no: audioNoNorming,
	nn: audioNnNorming,
};

class Intro extends React.Component {
	constructor(props) {
		super(props);
		const isNorming = this.props.isNorming ? 1 : 0;
		this.audio =
			isNorming === 1
				? audioObjNorming[strings.getLanguage()]
				: audioObj[strings.getLanguage()];
		this.ordkjedetestIntro =
			isNorming === 1
				? strings.ordkjedetestIntroNorming
				: strings.ordkjedetestIntro;
	}
	render() {
		const {onNextStep} = this.props;

		return (
			<div className="lit-intro">
				<p>
					<AudioPlayer
						autoplay
						inline
						src={this.audio}
						onErrorPlay={() => {
							console.log('Something went wrong');
						}}
					/>
					{strings.ordkjedetestIntro}
				</p>
				<button
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.showExamples}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
